import React, {
  useState,
  forwardRef,
  useImperativeHandle,
  useEffect,
  useMemo,
  useRef,
} from "react";

/* ================= PARSER ================= */
const parseProductName = (name = "") => {
  if (!name) return { brand: "", model: "" };

  const parts = name.trim().split(" ");
  return {
    brand: parts[0] || "",
    model: parts.slice(1).join(" "),
  };
};


const AddProductForm = forwardRef(
  ({ onAdd, initialData, products = [], onClose }, ref) => {

const fileInputRef = useRef(null);

    const defaultState = {
      product_condition: "",
      category: "",
      brand: "",
      model: "",
      name: "",
      price: "",
      stock: "",
      description: "",
      images: null,
    };

    const [formData, setFormData] = useState(defaultState);

    /* ================= RESET ================= */
        const resetForm = () => {
        setFormData(defaultState);


        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      };

    useImperativeHandle(ref, () => ({ resetForm }));

    /* ================= PREFILL ================= */
   useEffect(() => {
  if (initialData) {
    setFormData({
      product_condition: initialData.product_condition || "",
      category: initialData.category || "",
      brand: initialData.brand || "",
      model: initialData.model || "",
      name: initialData.name || "",
      price: initialData.price || "",
      stock: initialData.stock || "",
      description: initialData.description || "",
      images: null,
    });
  } else {
    setFormData(defaultState);
  }
}, [initialData]);

    /* ================= AUTO FILL ================= */
    useEffect(() => {
      if (!formData.name) return;

      const { brand, model } = parseProductName(formData.name);

      setFormData((prev) => ({
        ...prev,
        brand: prev.brand || brand,
        model: prev.model || model,
      }));
    }, [formData.name]);

    /* ================= OPTIONS ================= */
    const brandOptions = useMemo(() => {
      const set = new Set();
      products.forEach((p) => {
        const b = p.brand || p.name?.split(" ")[0];
        if (b) set.add(b);
      });
      return Array.from(set);
    }, [products]);

    const modelOptions = useMemo(() => {
      const set = new Set();
      products.forEach((p) => {
        const b = p.brand || p.name?.split(" ")[0];
        const m = p.model || p.name?.split(" ").slice(1).join(" ");
        if (b === formData.brand && m) set.add(m);
      });
      return Array.from(set);
    }, [products, formData.brand]);

    /* ================= HANDLE ================= */
    const handleChange = (e) => {
      const { name, value, files } = e.target;

      setFormData((prev) => ({
        ...prev,
        [name]: name === "images" ? files?.[0] : value,
      }));
    };

    /* ================= SUBMIT ================= */
  const handleSubmit = (e) => {
  e.preventDefault();

  const data = new FormData();

 Object.entries(formData).forEach(([k, v]) => {
  if (k === "images" && v instanceof File) {
    data.append("images", v);
  } else {
    data.append(k, v ?? "");
  }
});

  if (initialData?.id) {
    data.append("id", initialData.id);
  }

  onAdd?.(data);

    resetForm();
};

    return (
      <div className="relative bg-white rounded-xl shadow ">

       <h2 className="text-xl font-bold mb-4 ml-[20px]">
          {initialData ? "Edito Produkt" : "Shto Produkt"}
        </h2>

       <form onSubmit={handleSubmit} className="p-5 space-y-3">

          {/* CONDITION */}
          <select
            name="product_condition"
            value={formData.product_condition}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Gjendja</option>
            <option value="Te Reja">Te Reja</option>
            <option value="Te Perdorura">Te Perdorura</option>
          </select>

          {/* CATEGORY */}
          <select
            name="category"
            value={formData.category}
            onChange={handleChange}
            className="w-full p-2 border rounded"
          >
            <option value="">Kategoria</option>
            <option value="Laptop">Laptop</option>
            <option value="Telefona">Telefona</option>
            <option value="Tablet">Tablet</option>
            <option value="Kufje">Kufje</option>
          </select>

          {/* BRAND */}
          <input
            name="brand"
            value={formData.brand}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Brand"
          />

          {/* MODEL */}
          <input
            name="model"
            value={formData.model}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Model"
          />

          {/* NAME */}
          <input
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Emri"
          />

          {/* PRICE */}
          <input
            name="price"
            value={formData.price}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Cmimi"
          />

          {/* STOCK */}
          <input
            name="stock"
            type="number"
            value={formData.stock}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Stock"
          />

          {/* IMAGE UPLOAD */}
          <input
           ref={fileInputRef}
            type="file"
            name="images"
            accept="image/*"
            onChange={handleChange}
            className="w-full p-2 border rounded "
          />

          {/* DESCRIPTION */}
          <textarea
            name="description"
            value={formData.description}
            onChange={handleChange}
            className="w-full p-2 border rounded"
            placeholder="Pershkrimi"
          />

          {/* SUBMIT */}
          <button className="w-full bg-blue-600 text-white py-2 rounded">
            {initialData ? "Update Product" : "Shto Produkt"}
          </button>

        </form>
      </div>
    );
  }
);

export default AddProductForm;